import { render } from "./AppFooter.vue?vue&type=template&id=78dff83c&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=78dff83c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-78dff83c"

export default script